<template>
    <div>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item>
                    <i class='el-icon-lx-cascades'></i> 保险产品管理
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class='container'>
            <div class='handle-box'>




                <el-input v-model='query.name' placeholder='保险名称' class='handle-input mr10'
                          style='width: 160px'></el-input>
                <el-select v-model="query.isBoutique" placeholder="是否精品" class='handle-select mr10'  style='width: 200px'>
                    <el-option

                        v-for="item in boutiqueOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-select v-model="query.status" placeholder="是否上架" class='handle-select mr10' style='width: 200px'>
                    <el-option
                        v-for="item in statusOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-button type='primary' icon='el-icon-search' @click='handleSearch' class=' mr10'>查询</el-button>
                <el-button type='primary' icon='el-icon-search' @click='handleAdd' class=' mr10'>添加</el-button>

            </div>
            <el-table
                :data='tableData'
                border
                class='table'
                ref='multipleTable'
                header-cell-class-name='table-header'
            >

                <el-table-column label='序号' align='center' :index='indexMethod' type='index' width='40'>
                </el-table-column>
                <el-table-column prop='name' label='保险名称' align='center' width='80'>
                    <template slot-scope='scope'>{{ scope.row.name }}</template>
                </el-table-column>
                <el-table-column prop='area' label='保险类型' align='center' width='100'>
                    <template slot-scope='scope'>{{ scope.row.parentTypeName }}</template>

                </el-table-column>
                <el-table-column prop='area' label='保险期限' align='center'  width='80'>
                    <template slot-scope='scope'>{{ scope.row.timeTypeName }}</template>

                </el-table-column>
                <el-table-column prop='area' label='保险价格' align='center'  width='80'>
                    <template slot-scope='scope'>{{ scope.row.price/100 }}元</template>

                </el-table-column>
                <el-table-column prop='area' label='保险介绍' align='center' width='200'>
                    <template slot-scope='scope'>{{ scope.row.introduce }}</template>

                </el-table-column>
                <el-table-column label='缩略图' align='center'>
                    <template slot-scope='scope'>
                        <el-image

                            :fit="fit"
                            style='width: 200px; height: 200px'
                            :src='scope.row.photoUrl'
                            :preview-src-list='[scope.row.photoUrl]'>
                        </el-image>
                    </template>
                </el-table-column>


                <el-table-column label='主题图' align='center'>
                    <template slot-scope='scope'>
                        <el-image

                            :fit="fit"
                            style='width: 200px; height: 200px'
                            :src='scope.row.themeUrl'
                            :preview-src-list='scope.row.themeUrls'>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label='保险方案' align='center'>
                    <template slot-scope='scope'>
                        <el-image


                            style='width: 200px; height: 200px'
                            :src='scope.row.planUrl'
                            :preview-src-list='scope.row.planUrls'>
                        </el-image>
                    </template>
                </el-table-column>
                <el-table-column label='产品详情' align='center'>
                    <template slot-scope='scope'>
                        <el-image


                            style='width: 200px; height: 200px'
                            :src='scope.row.detailUrl'
                            :preview-src-list='scope.row.detailUrls'>
                        </el-image>
                    </template>
                </el-table-column>

                <el-table-column label='理赔流程' align='center'>
                    <template slot-scope='scope'>
                        <el-image


                            style='width: 200px; height: 200px'
                            :src='scope.row.processUrl'
                            :preview-src-list='scope.row.processUrls'>
                        </el-image>
                    </template>
                </el-table-column>



          <el-table-column label='操作' width='180' align='center'>
                    <template slot-scope='scope'>
                        <el-button
                            type='text'
                            icon='el-icon-edit'
                            @click='handleEdit(scope.$index, scope.row)'
                        >编辑
                        </el-button>
                        <el-button
                            type='text'
                            class='blue'
                            @click='handleStatus(scope.$index, scope.row)'
                        >{{ scope.row.status === 1 ? '下架' : '上架' }}
                        </el-button>
                        <el-button
                            type='text'
                            class='blue'
                            @click='handleBoutique(scope.$index, scope.row)'
                        >{{ scope.row.isBoutique === 1 ? '取消精品' : '设为精品' }}
                        </el-button>


                    </template>
              </el-table-column>
            </el-table>
            <div class='pagination'>
                <el-pagination
                    background
                    layout='total, prev, pager, next'
                    :current-page='query.pageIndex'
                    :page-size='query.pageSize'
                    :total='pageTotal'
                    @current-change='handlePageChange'
                ></el-pagination>
            </div>
        </div>
        <el-dialog title='添加保险产品' :visible.sync='addVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='90px'>
                <el-form-item label='保险缩略图'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.photoUrls'
                        ref='upload'
                        :limit="1"
                        :http-request='uploadPhotoFileTheme'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label='保险名称'>
                    <el-input v-model='createForm.name'></el-input>
                </el-form-item>
                <el-form-item label='主题图'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.themeUrlLocals'
                        ref='upload'
                        :limit="1"
                        :http-request='uploadFileTheme'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label='保险类型'>


                    <el-select v-model="createForm.parentType" placeholder="请选择保险类型" class='handle-select mr10'  style='width: 200px'>
                        <el-option

                            v-for="item in optionsValues"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
<!--                        <el-cascader-->
<!--                            style='width: 100%;margin-right: 20px'-->
<!--                            v-model=''-->
<!--                            :options='optionsValues'-->
<!--                            @change='handleChange'></el-cascader>-->

                </el-form-item>
                <el-form-item label='保险价格'>
                    <el-input v-model='createForm.price'  maxLength='8' type='number'></el-input>
                </el-form-item>
                <el-form-item label='保险期限'>
                    <el-select v-model="createForm.timeType" placeholder="请选择">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='保险介绍'>
                    <el-input v-model='createForm.introduce'></el-input>
                </el-form-item>

                <el-form-item label='保险方案'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.planUrlLocals'
                        ref='upload'
                        :limit="1"

                        :http-request='uploadFilePlan'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label='产品详情'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.detailUrlLocals'
                        ref='upload'
                        :limit="1"

                        :http-request='uploadFileDetailUrls'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label='理赔流程'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.processUrlLocals'
                        ref='upload'
                        :limit="1"

                        :http-request='uploadFileProcessUrls'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='addVisible = false'>取 消</el-button>
                <el-button type='primary' @click='addUserHttp'>确 定</el-button>
            </span>
        </el-dialog>

        <!-- 编辑弹出框 -->
        <el-dialog title='编辑保险产品' :visible.sync='editVisible' width='40%'>

            <el-form ref='form' :model='createForm' label-width='90px'>
                <el-form-item label='保险缩略图'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.photoUrlLocals'
                        ref='upload'
                        :limit="1"
                        :http-request='uploadPhotoFileTheme'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label='保险名称'>
                    <el-input v-model='createForm.name'></el-input>
                </el-form-item>
                <el-form-item label='主题图'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :limit="1"
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.themeUrlLocals'
                        ref='upload'
                        :http-request='uploadFileTheme'
                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label='保险类型'>

                    <el-select v-model="createForm.parentType" placeholder="请选择保险类型" class='handle-select mr10'  style='width: 200px'>
                        <el-option

                            v-for="item in optionsValues"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                        </el-select>
                </el-form-item>
                <el-form-item label='保险价格'>
                    <el-input v-model='createForm.price'  maxLength='8' type='number'></el-input>
                </el-form-item>
                <el-form-item label='保险期限'>
                    <el-select v-model="createForm.timeType" placeholder="请选择">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='保险介绍'>
                    <el-input v-model='createForm.introduce'></el-input>
                </el-form-item>

                <el-form-item label='保险方案'>
                    <el-upload
                        class='upload-demo'
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.planUrlLocals'
                        ref='upload'

                        :http-request='uploadFilePlan'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label='产品详情'>
                    <el-upload
                        class='upload-demo'
                        :limit="1"
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.detailUrlLocals'
                        ref='upload'

                        :http-request='uploadFileDetailUrls'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label='理赔流程'>
                    <el-upload
                        class='upload-demo'
                        :limit="1"
                        :on-preview='handlePreview'
                        :on-remove='handleRemove'
                        :before-upload='beforeAvatarUpload'
                        :file-list='createForm.processUrlLocals'
                        ref='upload'

                        :http-request='uploadFileProcessUrls'

                        list-type='picture'>
                        <el-button size='small' type='primary'>点击上传</el-button>
                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                </el-form-item>

            </el-form>
            <span slot='footer' class='dialog-footer'>
                <el-button @click='editVisible = false'>取 消</el-button>
                <el-button type='primary' @click='updateHttp'>确 定</el-button>
            </span>
        </el-dialog>

        <!--        <el-dialog title='编辑保险' :visible.sync='editVisible' width='40%'>-->


<!--            <el-form ref='form' :model='editForm' label-width='90px'>-->
<!--                <el-form-item label='保险名称'>-->
<!--                    <el-input v-model='name'></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='主题图'>-->
<!--                    <el-upload-->
<!--                        class='upload-demo'-->
<!--                        :on-preview='handlePreview'-->
<!--                        :on-remove='handleRemove'-->
<!--                        :before-upload='beforeAvatarUpload'-->
<!--                        :file-list='editForm.themeUrlLocals'-->
<!--                        ref='upload'-->
<!--                        :http-request='uploadFileTheme'-->
<!--                        list-type='picture'>-->
<!--                        <el-button size='small' type='primary'>点击上传</el-button>-->
<!--                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>-->
<!--                    </el-upload>-->
<!--                </el-form-item>-->

<!--                <el-form-item label='保险类型'>-->

<!--                    <el-cascader-->
<!--                        style='width: 100%;margin-right: 20px'-->
<!--                        v-model='editForm.typeIds'-->
<!--                        :options='optionsValues'-->
<!--                        @change='handleChange'></el-cascader>-->

<!--                </el-form-item>-->
<!--                <el-form-item label='保险价格'>-->
<!--                    <el-input v-model='editForm.price'  maxLength='8' type='number'></el-input>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='保险期限'>-->
<!--                    <el-select v-model="editForm.timeType" placeholder="请选择">-->
<!--                        <el-option-->
<!--                            v-for="item in options"-->
<!--                            :key="item.value"-->
<!--                            :label="item.label"-->
<!--                            :value="item.value">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='保险介绍'>-->
<!--                    <el-input v-model='editForm.introduce'></el-input>-->
<!--                </el-form-item>-->

<!--                <el-form-item label='保险方案'>-->
<!--                    <el-upload-->
<!--                        class='upload-demo'-->
<!--                        :on-preview='handlePreview'-->
<!--                        :on-remove='handleRemove'-->
<!--                        :before-upload='beforeAvatarUpload'-->
<!--                        :file-list='editForm.planUrlLocals'-->
<!--                        ref='upload'-->

<!--                        :http-request='uploadFilePlan'-->

<!--                        list-type='picture'>-->
<!--                        <el-button size='small' type='primary'>点击上传</el-button>-->
<!--                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>-->
<!--                    </el-upload>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='产品详情'>-->
<!--                    <el-upload-->
<!--                        class='upload-demo'-->
<!--                        :on-preview='handlePreview'-->
<!--                        :on-remove='handleRemove'-->
<!--                        :before-upload='beforeAvatarUpload'-->
<!--                        :file-list='editForm.detailUrlLocals'-->
<!--                        ref='upload'-->

<!--                        :http-request='uploadFileDetailUrls'-->

<!--                        list-type='picture'>-->
<!--                        <el-button size='small' type='primary'>点击上传</el-button>-->
<!--                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>-->
<!--                    </el-upload>-->
<!--                </el-form-item>-->
<!--                <el-form-item label='理赔流程'>-->
<!--                    <el-upload-->
<!--                        class='upload-demo'-->
<!--                        :on-preview='handlePreview'-->
<!--                        :on-remove='handleRemove'-->
<!--                        :before-upload='beforeAvatarUpload'-->
<!--                        :file-list='editForm.processUrlLocals'-->
<!--                        ref='upload'-->

<!--                        :http-request='uploadFileProcessUrls'-->

<!--                        list-type='picture'>-->
<!--                        <el-button size='small' type='primary'>点击上传</el-button>-->
<!--                        <div slot='tip' class='el-upload__tip'>只能上传jpg/png文件，且不超过2M</div>-->
<!--                    </el-upload>-->
<!--                </el-form-item>-->

<!--            </el-form>-->
<!--            <span slot='footer' class='dialog-footer'>-->
<!--                <el-button @click='editVisible = false'>取 消</el-button>-->
<!--                <el-button type='primary' @click='updateHttp()'>确 定</el-button>-->
<!--            </span>-->
<!--        </el-dialog>-->

    </div>
</template>

<script>
import { formatDate, formatDates } from '@/utils/formatDate';

export default {
    name: 'basetable',
    data() {
        return {
            enterpiseValue:"",
            queryEnterprise: {
                name: '',
                pageIndex: 1,
                pageSize: 999999
            },
            radio: '1',
            fileList: [],
            workType: '',
            value: [],
            options: [],

            query: {
                name: '',
                educationRank: '',
                pageIndex: 1,
                pageSize: 10
            },
            tableData: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            addVisible: false,
            workTypeIds:[],

            excelFile :null,
            boutiqueOptions:[{id:"",name:"请选择是否精品"},{id:0,name:"否"},{"id":1,name:"是"}],
            boutiqueValue:"",
            statusOptions:[{id:"",name:"请选择是否上架"},{id:0,name:"否"},{"id":1,name:"是"}],
            statusValue:"",

            createForm: {
                "typeIds":"",
                'timeType': '',
                'price': '',
                'name': '',
                'covenantUrl': '',
                'legalPersonUrl': '',
                'orzUrl': '',
                'isCustomerService': '1',
                'provinceId': '',
                'cityId': '',
                "themeUrl":"",
                "detailUrl":"",
                "planUrl":"",
                "processUrl":"",
                "themeUrlLocals":[],
                "planUrlLocals":[],
                "processUrlLocals":[],
                "detailUrlLocals":[]

            }
            ,
            editForm: {


            }
            ,
            pageTotal: 0,
            form: {},
            idx: -1,
            id: -1

        };
    },
    created() {
        this.getData();
        this.getWorkTypeList();
        this.getTimeTypeList();
        // this.getProvince();
        // this.getCity();
    },

    watch: {

        //监听内容

    },
    methods: {
        indexMethod(index) {
            return index + 1;
        },
        handlePreview(file) {

        },
        uploadFileTheme(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.themeUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.themeUrl;
                    // that.createForm.photoUrlList = [];
                    that.createForm.themeUrlLocals.push({ url: picUrl });
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadPhotoFileTheme(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.photoUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.photoUrl;
                   that.createForm.photoUrlList = [];
                    that.createForm.photoUrls.push({ url: picUrl });
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFilePlan(file) {
            let that = this;
            console.log('uploadFileLogo');
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.planUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.planUrl;
                    // that.createForm.photoUrlList = [];
                    that.createForm.planUrls.push({ url: picUrl });
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileProcessUrls(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.processUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.processUrl;
                  that.createForm.processUrls = [];
                    that.createForm.processUrls.push({ url: picUrl });
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileDetailUrls(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);

                    that.createForm.detailUrl = that.http.getDownLoadUrl() + res.data.data[0];
                    let picUrl = that.createForm.detailUrl;
                    that.createForm.detailUrls = [];
                    that.createForm.detailUrls.push({ url: picUrl });
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileCovenant(file) {
            let that = this;
            this.http.postFile('/local_file', file.file).then(res => {
                // 上传成功后的处理
                if (res.data.code == 0) {
                    console.log(res.data);
                    that.form.photoUrls=[{url:that.http.getDownLoadUrl() + res.data.data[0]}]

                    that.form.photoUrl =that.http.getDownLoadUrl() +  res.data.data[0];
                }
            }, err => {
                // 出现错误时的处理
            });
        },
        uploadFileLegalPerson(file) {
            let that = this;
            this.http.postFile('/uploadFile', file.file).then(res => {
                // 上传成功后的处理
                console.log(res.data);
                if (res.data.code == 0) {
                    that.createForm.legalPersonUrl = res.data.data;
                    that.form.legalPersonUrl = res.data.data;
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        },




        uploadFileOrzUrl(file) {
            let that = this;
            this.excelFile = file.file

        },
        beforeAvatarUpload(file) {

            return true;
        }
,

        // 获取 easy-mock 的模拟数据
        getData() {
            let that = this;
            this.http.getToken('/InsuranceProducts/getList', this.query).then(res => {
                    if (res.code == 0) {

                        that.tableData = res.data.records;
                        that.pageTotal = parseInt(res.data.total);
                        this.$message.success('获取数据成功');

                    }
                },
                err => {

                });
        }

,
        getTimeTypeList() {
            let that = this;
            this.http.getToken('/InsuranceProducts/getTimeTypeList', this.query).then(res => {
                    if (res.code == 0) {
                        that.options = res.data;

                    }
                },
                err => {

                });
        }

        ,
        // 触发搜索按钮
        handleSearch() {
            this.query.pageIndex = 1;
            this.getData();

        },
        delUserHttp(id) {
            let that = this;
            this.http.post('user/delUserById', { 'id': id, 'status': 1 }).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        that.$message.success('删除成功');
                    }
                },
                err => {

                });
        }
        ,

        editUserHttp(params) {
            let that = this;

            this.http.post('user/updateUserInfoByid', params).then(res => {
                    if (res.code == 0) {
                        that.getData();
                        this.editVisible = false;
                        that.$message.success('编辑成功');
                    }
                },
                err => {

                });
        }
        ,
        handleAdd() {
            this.createForm = {}
            this.createForm.themeUrlLocals=[]
            this.createForm.planUrlLocals=[]
            this.createForm.detailUrlLocals=[]
            this.createForm.processUrlLocals=[]
            this.addVisible = true;
        },
        // 删除操作
        handleDelete(index, row) {
            // 二次确认删除
            let that = this;
            this.$confirm('确定要删除吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.delUserHttp(row.id);

                })
                .catch(() => {
                });
        },

        addUser() {
            this.createForm = {};
            this.value = [];
            this.addVisible = true;


        },

        addUserHttp() {
          let  uid =  localStorage.getItem('uid');


            let that = this;
            let params = JSON.parse(JSON.stringify(this.createForm))
            params.detailUrls=[]
            params.processUrls=[]
            params.processUrls = []
            params.detailUrls=[]
            params.planUrls=[]
            params.photoUrls=[]
            this.http.postToken('/InsuranceProducts/add',params ).then(res => {
                // 上传成功后的处理
                console.log("data"+JSON.stringify(res))
                if (res.code == 0) {
                    that.$message.success("添加成功")
                    that.getData();
                    that.addVisible = false

                }else {
                    that.$message.error(res.data.msg)
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        }
        ,
       updateHttp() {
            let  uid =  localStorage.getItem('uid');

            let that = this;
            let params =JSON.parse( JSON.stringify(this.createForm))
            params.processUrls = []
            params.detailUrls=[]
         params.planUrls=[]
           params.photoUrls=[]

           this.http.postToken('/InsuranceProducts/update',params ).then(res => {
                // 上传成功后的处理
                console.log("data"+JSON.stringify(res))
                if (res.code == 0) {
                    that.$message.success("编辑成功")
                    that.getData();
                    that.editVisible = false

                }else {
                    that.$message.error(res.data.msg)
                }
            }, err => {
                // 出现错误时的处理
                console.log(res);
            });
        }
        ,
        delAllSelection() {
            const length = this.multipleSelection.length;
            let str = '';
            this.delList = this.delList.concat(this.multipleSelection);
            for (let i = 0; i < length; i++) {
                str += this.multipleSelection[i].name + ' ';
            }
            this.$message.error(`删除了${str}`);
            this.multipleSelection = [];
        },
        handleStatus(index,row){
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.status == 0) {
                msg = '确定要' + '上架' + '吗？';
                params = { 'id': row.id, 'status': 1 };
            } else {
                msg = '确定要' + '下架' + '吗？';
                params = { 'id': row.id, 'status': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('/InsuranceProducts/updateStatus', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        //设置精品
        handleBoutique(index, row) {
            // 二次确认删除
            console.log(index);
            console.log(row.uid);
            let that = this;
            let params = {};
            let msg = '';
            if (row.isBoutique == 0) {
                msg = '确定要' + '设置为精品' + '吗？';
                params = { 'id': row.id, 'isBoutique': 1 };
            } else {
                msg = '确定要' + '取消精品' + '吗？';
                params = { 'id': row.id, 'isBoutique': 0 };
            }

            this.$confirm(msg, '提示', {
                type: 'warning'
            })
                .then(() => {
                    that.http.postToken('/InsuranceProducts/updateIsBoutique', params).then(res => {
                        if (res.code == 0) {
                            that.getData();
                            this.$message.success('操作成功');
                        }
                    });

                })
                .catch(() => {
                });
        },
        getWorkTypeList() {
            let that = this;
            this.query.enterpriseId = this.enterpiseValue;
            this.http.get('/workType/getWorkTypeList', this.query).then(res => {
                    if (res.code == 0) {
                        that.optionsValues = res.data;
                    }
                },
                err => {

                });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.createForm = JSON.parse(JSON.stringify(row));
            this.editForm.name = row.name;
            this.createForm.id = row.id;
            this.createForm.themeUrl = row.themeUrl
            this.createForm.planUrl = row.planUrl
            this.createForm.detailUrl = row.detailUrl
            this.createForm.processUrl = row.processUrl
            this.createForm.price = row.price/100
            this.createForm.introduce = row.introduce
            this.createForm.parentType= row.parentType+""
            this.createForm.timeType=row.timeType+""
            this.createForm.themeUrlLocals = [{"url":row.themeUrl}];
            this.createForm.planUrlLocals = [{"url":row.planUrl}];
            this.createForm.detailUrlLocals = [{"url":row.detailUrl}];
            this.createForm.processUrlLocals = [{"url":row.processUrl}];
            this.createForm.photoUrlLocals = [{"url":row.photoUrl}];

            this.editVisible = true;
        },
        // 保存编辑
        saveEdit() {
            if (this.cityId==null || this.cityId.length==0){
                this.$message.error("求职地址不能为空")
                return
            }
            if (this.workTypeIds==null || this.workTypeIds.length==0){
                this.$message.error("求职地址不能为空")
                return
            }
            this.form.city_id=this.cityId[1]
            this.form.workTypeId=this.workTypeIds[2];
            this.editUserHttp(this.form);
        },
        // 分页导航
        handlePageChange(val) {
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        }
    }
};
</script>

<style scoped>

.avatar-uploader .el-upload {
    border-radius: 6px;
    width: 80px;
    height: 80px;
    text-align: center;

}

.avatar-uploader {
    border-color: #409EFF;
    text-align: center;
    margin-bottom: 40px;
    text-align: center;

}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
    text-align: center;
}

.avatar {
    width: 80px;
    height: 80px;
    display: block;
    margin: auto auto;
    text-align: center;
}

.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
